import React from 'react';
import classes from './PageLoading.module.scss';

const PageLoading = () => {
    return (
        <div className={classes.loading}>
            <span>C</span>
            <span>a</span>
            <span>r</span>
            <span>g</span>
            <span>a</span>
            <span>n</span>
            <span>d</span>
            <span>o</span>
            <span>.</span>
            <span>.</span>
            <span>.</span>
        </div>
    );
};

export default PageLoading;
